import { FieldNode } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

export function checkIsRequesterHasEmptyFieldValue(fields: DeepReadonly<FieldNode[]>) {
  return fields
    .filter((field) => field.participantReference.type === 'REQUESTER')
    .some((field) => {
      if (field.type === 'CHECKBOX' || field.type === 'TEXT') {
        return !field.input?.value;
      }
      if (field.type === 'IMAGE') {
        return !field.input?.value.fileId || !field.input?.value.otp;
      }
      return false;
    });
}
